import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/tooltipBoxStyles';
import { alignElementToMousePointer } from '../../../utils/htmlElement.utils';

export class GzTooltipBoxWebComponent extends LitElement {
  @property({ type: String, reflect: true })
  text = '';

  static get styles() {
    return styles;
  }

  constructor(public triggerEvent: MouseEvent) {
    super();
  }

  render() {
    this.updateComplete.then(() => {
      alignElementToMousePointer(this.triggerEvent, this);
    });

    return html` ${this.text} `;
  }
}
